/** Gemeinsame Inhaltsbreiten; Qeddy ist die ausdrücklich freigegebene schmale Ausnahme. */
export const drawerWidths = {
  standard: "min(720px, 96vw)",
  wide: "min(960px, 96vw)",
  qeddy: "min(420px, 96vw)",
} as const;
